// ToDO: need to shift this config to DB
export const connectorsConfig = {
  o365_group: {
    description:
      'Use me to sync Office 365 - Users & Groups of your organization with xift'
  },
  o365_onedrive: {
    description:
      'Use me to sync Office 365 - Onedrive data of your organization with xift'
  },
  o365_sharepoint: {
    description:
      'Use me to sync Office 365 - Sharepoint data of your organization with xift'
  },
  o365_teams: {
    description:
      'Use me to sync Office 365 - Teams chat data of your organization with xift'
  },
  o365_email: {
    description:
      'Use me to sync Office 365 - Outlook mails of your organization with xift'
  },
  ediscovery_project_export: {
    description: 'Use me to give consent for file Export/Restore to OneDrive'
  },
  o365_sso: {
    description: 'Single sign-on signifies access to your apps from anywhere'
  },
  dropbox: {
    description: 'Use me to sync Dropbox of your organization with xift'
  },
  export_to_dropbox: {
    description: 'Use me to give consent for file Export/Restore to Dropbox'
  }
};
